import FileUpload from "components/FileUpload";
import FileView from "components/fileView";
import DynamicFormInput from "components/form/form";
import TabNav from "components/TabNav";
import { useToast } from "contexts/ToastContext";
import { FileUp } from "lucide-react";
import { useState } from "react";
import { updateLegalAdvisory } from "services/legalAdvisoryService";
import { updateLegislativeDrafting } from "services/legislativeService";
import ShowUI, { LEGISLATIVE_DRAFTING_UI_RULES } from "utils/authRules";
import { LoadingIcon } from "utils/constant";
import { LEGAL_ADVISORY_REQUEST_STATUS, LEGAL_RESEARCH_REGISTRAR_TABS, LEGAL_RESEARCH_REQUEST_STATUS, LEGISLATIVE_DRAFTING_REQUEST_STATUS } from "utils/constantValues";
import { formatDay } from "utils/helpers";
import LegislativeDraftDetail from "./fragments/leftPanel";
import LegislativeDraftRightPanel from "./fragments/rightPanel";
import { useTranslation } from "react-i18next";
import { appendOfficeStamp } from "services/stampService";

export default function RegistrarLegislativeDraft({ request }: { request: any }) {
    const { t } = useTranslation();
    const [activeTab, setActiveTab] = useState("Research Finding");
    const [letterRefNum, setLetterRefNum] = useState("");
    const [submitting, setSubmitting] = useState(false);
    const [messenger_name, setMessengerName] = useState("");
    const [proposalFile, setProposalFile] = useState();
    const { showToast } = useToast();
    
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setLetterRefNum(e.target.value)
    }
    
    const handleFileChange = (
        file: any,
    ) => {
        setProposalFile(file);
    };

    const [formState, setFormState] = useState({ ...request });

    const handleSave = async () => {
        setSubmitting(true);
        const data = new FormData();
        data.append(
            "status",
            LEGAL_ADVISORY_REQUEST_STATUS.letter_refnum_submitted.value
        );
        data.append(
            "forward_status",
            LEGAL_ADVISORY_REQUEST_STATUS.assigned_to_prosecutor.value
        );
        data.append("letter_reference_number", letterRefNum);
        data.append("messenger_name", messenger_name);
        data.append("registry_number", letterRefNum);
        if (proposalFile) {
            data.append("completion_letter", proposalFile);
            // Office stamp from HRMS: the backend stamps the PDF before storing it.
            await appendOfficeStamp(data);
        }

        try {
            const response = await updateLegalAdvisory(formState.id, data);

            setFormState({ ...response });
            showToast(t("LegalResearchRespondedBackSuccess") || "Legal research responded back successfully!", "success");
        } catch (error) {
            console.error("Error submitting request:", error);
            showToast(t("FailedToUpdateLegalResearchRequest") || "Failed to update legal research request.", "error");
        } finally {
            setSubmitting(false);
            setLetterRefNum("");
        }
    };

    return (
        <div className="flex-1">
            <ShowUI
                ui_key={LEGISLATIVE_DRAFTING_UI_RULES.edit_reference_number.value}
                currentStatus={formState.status}
                forwardStatus={formState.forward_status}
            >
                {activeTab === "Research Finding" &&
                    <div className="flex w-full gap-8">
                        <div className="flex flex-col flex-1 max-w-4xl bg-white rounded-lg shadow-md p-6 mb-4 h-fit">
                            <DynamicFormInput
                                inputs={[
                                    {
                                        value: letterRefNum,
                                        type: "text",
                                        label: t("LetterReferenceNumber") || "Letter Reference Number",
                                        name: "letter_reference_number",
                                        onChange: handleChange,
                                        placeholder: t("LetterReferenceNumberPlaceholder") || "Eg. 12345",
                                    },
                                ]} />
                            <div className="mb-6">
                                <label
                                    htmlFor="deadline"
                                    className="block text-sm font-medium text-gray-700 mb-2"
                                >
                                    {t("LegalAdviceCompletionLetter") || "Legal Advice Completion Letter"}
                                </label>
                                <div className="relative">
                                    <FileUpload onChange={handleFileChange} />
                                </div>
                            </div>
                            <button 
                                onClick={handleSave} 
                                disabled={submitting}
                                className="bg-[#0A1D39] hover:bg-[#13294d] mt-4 text-white font-bold py-3 px-8 rounded-md w-full disabled:opacity-70"
                            >
                                {submitting ? (
                                    <div className="flex items-center justify-center">
                                        {LoadingIcon} {t("Submitting") || "Submitting..."}
                                    </div>
                                ) : (
                                    t("Save") || "Save"
                                )}
                            </button>
                        </div>
                    </div>
                }
            </ShowUI>
        </div>
    );
}